import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import session from './session';
import companies from './companies';
import account from './account';
import crs from './crs';
import discount from './discount';
import app from './app';
import workspaces from './workspaces';
import modal from './modal';
import error from './error';
import cloudFolders from './cloudFolders';
import quickMessages from './quickMessages';
import preloader from './preloader';
import chargebeeLoader from './chargebeeLoader';
import mls from './mls';

export default combineReducers({
	routing: routerReducer,
	session,
	companies,
	account,
	app,
	crs,
	discount,
	workspaces,
	modal,
	error,
	cloudFolders,
	quickMessages,
	preloader,
	chargebeeLoader,
	mls
});



// WEBPACK FOOTER //
// ./src/redux/modules/index.js